// Forgot Password Page JavaScript
// Handles email validation and form submission

(function() {
    'use strict';

    const form = document.getElementById('forgotPasswordForm');
    if (!form) return;

    const emailInput = document.getElementById('email');
    const submitBtn = document.getElementById('submitBtn');

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    /**
     * Validate email format
     */
    function validateEmail() {
        const email = emailInput.value.trim();
        
        if (!email) {
            emailInput.classList.add('is-invalid');
            emailInput.classList.remove('is-valid');
            return false;
        }

        if (!emailRegex.test(email)) {
            emailInput.classList.add('is-invalid');
            emailInput.classList.remove('is-valid');
            return false;
        }

        emailInput.classList.remove('is-invalid');
        emailInput.classList.add('is-valid');
        return true;
    }

    /**
     * Real-time validation on input
     */
    emailInput.addEventListener('input', function() {
        validateEmail();
    });

    /**
     * Handle form submission
     */
    form.addEventListener('submit', function(e) {
        e.preventDefault();

        // Validate form
        if (!validateEmail()) {
            emailInput.focus();
            Toast.warning('Please enter a valid email address');
            return;
        }

        // Disable submit button to prevent double submission
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Sending...';

        // Submit form — with reCAPTCHA v3 if configured
        if (window.recaptchaSiteKey) {
            grecaptcha.ready(function () {
                grecaptcha.execute(window.recaptchaSiteKey, { action: 'forgot_password' }).then(function (token) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'g-recaptcha-response';
                    input.value = token;
                    form.appendChild(input);
                    form.submit();
                });
            });
        } else {
            form.submit();
        }
    });

    // Auto-focus email input
    if (emailInput) {
        emailInput.focus();
    }

})();
